import '../css/style.scss'
import Glide from '@glidejs/glide'

import newsOverlay from './newsOverlay/newsOverlay'

import LightBox from './popup/LightBox'

const glides = document.querySelectorAll('.glide-slider');

if(glides) glides.forEach(glide => {
  const glideContainer = glide.querySelector('.glide');
  if(!glideContainer) return false;
  const gslider = new Glide(glideContainer, {gap:0, autoplay:5000,swipeThreshold:20, type:'carousel'});
  const controls = glide.querySelectorAll('[data-glide-go]');
  controls.forEach(control => control.addEventListener('click',e=>{
    const action = control.dataset.glideGo;
    console.log(action)
    gslider.go(control.dataset.glideGo);
  }))
  gslider.mount();
})

/* if(glides.length) {
  const glslider = new Glide('.glide', {gap:0, autoplay:5000,swipeThreshold:20});
  console.log(glslider);
  glslider.mount();
  
  const links = document.querySelectorAll('.glide a');
  
  links.forEach(link => {
    link.addEventListener('mousedown', e => {
      link.clicked = true;
      setTimeout(()=> {
        link.clicked = false;
      },100)
    });

  
    link.addEventListener('mouseup',e=>{
      if(link.clicked) {
        const url = link.getAttribute('href')
        if(url) window.location = url; 
      }
    })
  });
} */

/* const employeesSliderElement = document.querySelector('.employees__slider');

if(employeesSliderElement) {
  const employeesSlider = new Glide('.employees__slider',{gap:10,autoplay:false});
  employeesSlider.mount();
  document.addEventListener("showEmployee",e => {
    employeesSlider.go(`=${e.detail.index}`)
  })
  const employees = document.querySelectorAll('.employees__list a');
  console.log(employees);
  if(employees) employees.forEach((employee,index) => {
    employee.addEventListener('click', e=> {
      const event = new CustomEvent("showEmployee",{bubbles: true,detail: {index}});      
      e.target.dispatchEvent(event);
    });
  });
} */

const menuTrigger = document.querySelectorAll(".menu__trigger, .menu-toggle");
menuTrigger.forEach(trigger => {
  trigger.addEventListener('click',e=>{
    e.preventDefault();
    document.body.classList.toggle('menu-on');
  })
})

const menuToggle = document.querySelectorAll(".menu-menu-1-container a");
menuToggle.forEach(trigger => {
  trigger.addEventListener('click',e=>{
    document.body.classList.toggle('menu-on');
  })
})


const paralaxElements = document.querySelectorAll('[data-paralax]');
window.addEventListener('scroll',e=>{
  paralaxElements.forEach( paralaxElement => {
    const clientRect =  paralaxElement.getBoundingClientRect();
    const offset = (clientRect.y - window.innerHeight/2) * paralaxElement.dataset.paralax;
    paralaxElement.style.transform = `translateY(${offset}px)`;
  })
})

const overlay = newsOverlay();

const newsOverlays = document.querySelectorAll('[data-news-overlay-show]')
newsOverlays.forEach(overlayTrigger => {
  overlayTrigger.addEventListener('click',e=>{
    e.preventDefault();
    overlay.loadPost(overlayTrigger.dataset.newsOverlayShow);
  })
})


const lightBox = new LightBox({
  beforeContentAppend : content => {
    content = content.replace(/(?:src=\"(.*?)\")/, "src=\"$1?autoplay=1\"");
    return content;
  }
});

function zero(nr) {
  return (nr < 10? "0" : "")+nr;
}

document.body.addEventListener('click', e=> {
  const concertsLink = e.target.closest("[data-concerts]");
  if(!concertsLink) return false;
  e.preventDefault();
  let {page,artist,archive} = concertsLink.dataset;
  page = parseInt(page);
  const endpoint =  `${window.restURL}rh/v2/concerts/${artist? artist+"/": ""}${archive == 1? "archive/": ""}${page>1 ? "page/"+page: ""}`;
  fetch(endpoint).then(response => response.json()).then(data => {
    if(data.concerts) data.concerts.forEach(concert => {
      const concertDiv = document.createElement('div');
      concertDiv.classList.add("concert__single");
      const date = new Date(concert.concert_date.replace(' ','T'));
      const month = date.getMonth() +1;
      concertDiv.innerHTML = `
        <div class="concert__artist"><h3>${concert.artist}</h3></div>
        <div class="concert__date"><h3>${zero(date.getDate())}.${zero(month)}.${date.getFullYear()}</h3><p>${zero(date.getHours())}:${zero(date.getMinutes())}</p></div>
        <div class="concert__address"><h3>${concert.city}</h3><p>${concert.place}</p></div>
        <div class="concert__type"><p>${concert.type}</p></div>
        <div class="concert__tickets"><p>${concert.tickets_url? concert.tickets : ''}</p></div>
      `;
      concertsLink.parentElement.parentElement.insertBefore(concertDiv,concertsLink.parentElement);
    });
    if(data.total_pages >= page + 1) concertsLink.dataset.page = page+1;
    else concertsLink.remove();
  });  
})